import * as Cookies from 'js-cookie';
var AccessTokenStorage = /** @class */ (function () {
    function AccessTokenStorage(cookieName, options) {
        this.cookieName = cookieName;
        this.options = options;
    }
    AccessTokenStorage.prototype.load = function () {
        var _a;
        return (_a = Cookies.get(this.cookieName)) !== null && _a !== void 0 ? _a : null;
    };
    AccessTokenStorage.prototype.save = function (token) {
        if (token === null) {
            Cookies.remove(this.cookieName, this.options);
            if (this.load() !== null) {
                throw new Error("Failed to remove cookie ".concat(this.cookieName));
            }
            return;
        }
        Cookies.set(this.cookieName, token, this.options);
        if (this.load() !== token) {
            throw new Error("Failed to set cookie ".concat(this.cookieName));
        }
    };
    return AccessTokenStorage;
}());
export { AccessTokenStorage };
